import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import EngineHeader from "../Equip2/EngineHeader";
import { Card, CardBody, Container } from "reactstrap";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
  .alarm-wrap * { box-sizing: border-box; margin: 0; padding: 0; font-family: 'DM Sans', sans-serif; }

  /* TOP BAR */
  .al-topbar {
    display: flex; align-items: center; justify-content: space-between;
    background: #fff; padding: 0 24px; height: 56px;
    border-bottom: 1px solid #e8eaf0; position: sticky; top: 0; z-index: 100;
  }
  .al-topbar-left { display: flex; align-items: center; gap: 12px; }
  .al-logo { display: flex; align-items: center; gap: 8px; font-size: 17px; font-weight: 700; color: #1a1d2e; }
  .al-logo-icon { width: 30px; height: 30px; background: linear-gradient(135deg,#4f8ef7,#a259ff); border-radius: 8px; display:flex;align-items:center;justify-content:center;color:#fff;font-size:14px;font-weight:800; }
  .al-topbar-right { display: flex; align-items: center; gap: 14px; }
  .al-icon-btn { background:none;border:none;cursor:pointer;color:#888;font-size:18px;position:relative; }
  .al-notif-badge { position:absolute;top:-4px;right:-4px;background:#e53935;color:#fff;font-size:10px;font-weight:700;border-radius:50%;width:16px;height:16px;display:flex;align-items:center;justify-content:center; }
  .al-user-btn { display:flex;align-items:center;gap:6px;background:none;border:none;cursor:pointer;font-size:14px;color:#1a1d2e;font-weight:500; }
  .al-avatar { width:28px;height:28px;border-radius:50%;background:#4f8ef7;color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700; }

  /* SECOND NAV */
  .al-subnav { background:#fff;border-bottom:1px solid #e8eaf0;display:flex;align-items:center;padding:0 24px;height:48px;gap:0; }
  .al-subnav-brand { font-size:15px;font-weight:700;margin-right:16px;white-space:nowrap;color:#1a1d2e; }
  .al-vessel-pill { display:flex;align-items:center;gap:6px;border:1px solid #e8eaf0;border-radius:6px;padding:4px 10px;font-size:13px;color:#444;margin-right:20px;cursor:pointer;white-space:nowrap; }
  .al-vessel-cal { color:#4f8ef7; }
  .al-nav-tabs { display:flex;align-items:center;flex:1; }
  .al-nav-tab { background:none;border:none;cursor:pointer;font-size:13px;color:#666;padding:14px 14px;position:relative;white-space:nowrap;font-weight:500;text-decoration:none;display:block; }
  .al-nav-tab.active { color:#4f8ef7;font-weight:700; }
  .al-nav-tab.active::after { content:'';position:absolute;bottom:0;left:0;right:0;height:2px;background:#4f8ef7;border-radius:2px 2px 0 0; }
  .al-subnav-right { display:flex;align-items:center;gap:8px;margin-left:auto; }
  .al-badge-red { background:#e53935;color:#fff;border-radius:50%;width:20px;height:20px;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center; }
  .al-badge-yellow { background:#f59e0b;color:#fff;border-radius:50%;width:20px;height:20px;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center; }
  .al-utc { font-size:12px;color:#888;margin-left:6px;white-space:nowrap; }

  /* MAIN */
  .al-main { padding: 24px; background: #f4f6fb; min-height: calc(100vh - 104px); }

  /* OVERVIEW HEADER */
  .al-overview-hdr { display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:20px; }
  .al-overview-title { display:flex;align-items:center;gap:10px; }
  .al-shield { width:36px;height:36px;background:#fff3f3;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:18px; }
  .al-overview-title h2 { font-size:17px;font-weight:700;color:#1a1d2e; }
  .al-overview-title p { font-size:12px;color:#888;margin-top:2px; }
  .al-refresh-btn { display:flex;align-items:center;gap:6px;border:1px solid #e8eaf0;border-radius:8px;padding:8px 14px;background:#fff;cursor:pointer;font-size:13px;color:#4f8ef7;font-weight:500; }

  /* STAT CARDS */
  .al-stat-cards { display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-bottom:24px; }
  .al-stat-card { background:#fff;border-radius:12px;padding:20px;display:flex;align-items:center;justify-content:space-between;border:1px solid #f0f2f7; }
  .al-stat-card.redColor { border-left:4px solid #e53935; }
  .al-stat-card.yellow { border-left:4px solid #f59e0b; }
  .al-stat-card.orange { border-left:4px solid #ff6b35; }
  .al-stat-left { display:flex;align-items:center;gap:14px; }
  .al-stat-icon { width:44px;height:44px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px; }
  .al-stat-icon.red-bg { background:#fff0f0; }
  .al-stat-icon.yellow-bg { background:#fffbeb; }
  .al-stat-icon.orange-bg { background:#fff4f0; }
  .al-stat-num { font-size:28px;font-weight:700; }
  .al-stat-num.red { color:#e53935; }
  .al-stat-num.yellow { color:#f59e0b; }
  .al-stat-num.orange { color:#ff6b35; }
  .al-stat-label { font-size:13px;color:#888;margin-top:2px; }
  .al-stat-arrow { width:32px;height:32px;border:1px solid #e8eaf0;border-radius:50%;display:flex;align-items:center;justify-content:center;color:#aaa;cursor:pointer; }

  /* TABLE SECTION */
  .al-table-section { background: #fff;border-radius:12px;border:1px solid #f0f2f7;overflow:hidden; }
  .al-toolbar { display:flex;align-items:center;gap:8px;padding:14px 16px;border-bottom:1px solid #f0f2f7;flex-wrap:wrap; }
  .al-filter-tabs { display:flex;align-items:center;gap:6px;flex:1;flex-wrap:wrap; }
  .al-ftab { border:none;border-radius:20px;padding:6px 14px;font-size:13px;cursor:pointer;font-weight:500;transition:all 0.15s;background:#fff; }
  .al-ftab.all { background:#e8f0fe;color:#4f8ef7;font-weight:700; }
  .al-ftab.active-t { color:#e53935;border:1px solid #fcd4d4; }
  .al-ftab.unack { color:#f59e0b;border:1px solid #fde68a; }
  .al-ftab.resolved { color:#22c55e;border:1px solid #bbf7d0; }
  .al-toolbar-right { display:flex;align-items:center;gap:8px; }
  .al-search-box { display:flex;align-items:center;gap:8px;border:1px solid #e8eaf0;border-radius:8px;padding:7px 12px;background:#fafbfc; }
  .al-search-box input { border:none;background:none;font-size:13px;color:#333;outline:none;width:160px; }
  .al-search-box input::placeholder { color:#bbb; }
  .al-tool-btn { display:flex;align-items:center;gap:6px;border:1px solid #e8eaf0;border-radius:8px;padding:7px 12px;background:#fff;cursor:pointer;font-size:13px;color:#444;font-weight:500; }

  /* TABLE */
  .al-table { width:100%;border-collapse:collapse; }
  .al-table thead tr { background: #230462; }
  .al-table thead th { padding:13px 14px;text-align:left;font-size:12px;font-weight:600;color:#c8cbd8;letter-spacing:0.03em;white-space:nowrap; }
  .al-table tbody tr { border-bottom:1px solid #f4f6fb;transition:background 0.1s; }
  .al-table tbody tr:hover { background:#fafbff; }
  .al-table tbody td { padding:14px 14px;font-size:13px;color:#2d3142;vertical-align:middle; }
  .al-alarm-detail { font-weight:500;color:#1a1d2e;margin-bottom:4px; }
  .al-alarm-tag { display:inline-block;background:#e8f0fe;color:#4f8ef7;border-radius:4px;font-size:11px;font-weight:500;padding:2px 8px;margin-top:3px; }
  .al-alarm-tag.aux { background:#fef3c7;color:#b45309; }
  .al-dt-main { color:#333;font-weight:500; }
  .al-dt-sub { color:#aaa;font-size:11px;margin-top:2px; }

  /* BADGES */
  .al-badge { display:inline-flex;align-items:center;padding:4px 12px;border-radius:20px;font-size:12px;font-weight:600; }
  .al-badge-critical { background:#e53935;color:#fff; }
  .al-badge-high { background:transparent;color:#f59e0b;border:1.5px solid #f59e0b; }
  .al-badge-medium { background:#3b82f6;color:#fff; }
  .al-badge-low { background:#e5e7eb;color:#666; }

  /* OCCURRENCE */
  .al-occ { display:flex;align-items:center;gap:2px; }
  .al-occ-bar { width:4px;height:16px;border-radius:2px; }
  .al-occ-bar.red { background:#e53935; }
  .al-occ-bar.yellow { background:#f59e0b; }
  .al-occ-bar.blue { background:#3b82f6; }

  /* SUBSCRIBERS */
  .al-subs { display:flex;align-items:center;gap:6px;color:#555; }

  /* ACTION BTNS */
  .al-action-btns { display:flex;gap:8px;align-items:center; }
  .al-ack-btn { border:1.5px solid #e53935;background:none;color:#e53935;border-radius:6px;padding:5px 12px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;transition:all 0.15s; }
  .al-ack-btn:hover { background:#e53935;color:#fff; }
  .al-view-btn { border:1.5px solid #22c55e;background:none;color:#22c55e;border-radius:6px;padding:5px 12px;font-size:12px;font-weight:600;cursor:pointer;transition:all 0.15s; }
  .al-view-btn:hover { background:#22c55e;color:#fff; }

  /* PAGINATION */
  .al-pag-row { display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-top:1px solid #f0f2f7; }
  .al-pag-info { font-size:12px;color:#888; }
  .al-pag-btns { display:flex;align-items:center;gap:4px; }
  .al-pag-btn { width:30px;height:30px;border:1px solid #e8eaf0;border-radius:6px;background:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:13px;color:#555;font-weight:500;transition:all 0.1s; }
  .al-pag-btn.active { background:#4f8ef7;color:#fff;border-color:#4f8ef7;font-weight:700; }
  .al-pag-btn:hover:not(.active) { background:#f4f6fb; }
`;

const OccBars = ({ count, color }) => (
  <div className="al-occ">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className={`al-occ-bar ${color}`} />
    ))}
  </div>
);

const CriticalityBadge = ({ level }) => {
  const map = {
    Critical: "al-badge al-badge-critical",
    High: "al-badge al-badge-high",
    Medium: "al-badge al-badge-medium",
    Low: "al-badge al-badge-low",
  };
  return <span className={map[level] || "al-badge"}>{level}</span>;
};

const AlarmPage = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [alarms, setAlarms] = useState([]);
const [selectedDate, setSelectedDate] = useState(
  new Date().toISOString().split("T")[0]
);
  useEffect(() => {
    setAlarms([
      { id: 1, details: "AL: 2F North side corridor-2 AHU Return Air Temp > 27°C", tag: "Main Engine", tagType: "main", time: "Today, 12:29 PM", date: "04-06-2026", criticality: "Critical", occCount: 5, occColor: "red" },
      { id: 2, details: "AL: 2F MR1 1 AHU OFF", tag: "Main Engine", tagType: "main", time: "Yesterday, 11:35 PM", date: "03-06-2026", criticality: "High", occCount: 4, occColor: "yellow" },
      { id: 3, details: "8F Waiting Area 1 AHU Return Air Temp > 27°C", tag: "Auxiliary Engine", tagType: "aux", time: "2 Days Ago, 11:05 PM", date: "02-06-2026", criticality: "High", occCount: 4, occColor: "yellow" },
      { id: 4, details: "4F ICU 1 area temp=23 & valve position=10", tag: "Main Engine", tagType: "main", time: "14/07/2024, 10:15 PM", date: "", criticality: "Critical", occCount: 5, occColor: "red" },
      { id: 5, details: "Condenser Water Pump 4 is not in Recipe Mode", tag: "Main Engine", tagType: "main", time: "14/07/2024, 10:15 PM", date: "", criticality: "Medium", occCount: 4, occColor: "blue" },
    ]);
  }, []);

  return (
     <React.Fragment>
          <div className="page-content">
          
                      <Card className="em-card">

                        <EngineHeader activePage="Alarms"
            selectedDate={selectedDate}
  setSelectedDate={setSelectedDate}
            />

               <CardBody className="em-body">
    <div className="alarm-wrap">
      <style>{styles}</style>


      {/* MAIN */}
      <div className="al-main">
        {/* Overview Header */}
        <div className="al-overview-hdr">
          <div className="al-overview-title">
            <div className="al-shield">🛡️</div>
            <div>
              <h2>Alarm Overview</h2>
              <p>Real-time monitoring of equipment alarms and notifications</p>
            </div>
          </div>
          <button className="al-refresh-btn">↻ Refresh</button>
        </div>

        {/* Stat Cards */}
        <div className="al-stat-cards">
          <div className="al-stat-card redColor">
            <div className="al-stat-left">
              <div className="al-stat-icon">🔔</div>
              <div>
                <div className="al-stat-num">92</div>
                <div className="al-stat-label">Active Alarms</div>
              </div>
            </div>
            <div className="al-stat-arrow">→</div>
          </div>
          <div className="al-stat-card yellow">
            <div className="al-stat-left">
              <div className="al-stat-icon yellow-bg">🔔</div>
              <div>
                <div className="al-stat-num yellow">20</div>
                <div className="al-stat-label">Unacknowledged Alarms</div>
              </div>
            </div>
            <div className="al-stat-arrow">→</div>
          </div>
          <div className="al-stat-card orange">
            <div className="al-stat-left">
              <div className="al-stat-icon orange-bg">⚠️</div>
              <div>
                <div className="al-stat-num orange">10</div>
                <div className="al-stat-label">Critical Alarms</div>
              </div>
            </div>
            <div className="al-stat-arrow">→</div>
          </div>
        </div>

        {/* Table Section */}
        <div className="al-table-section">
          <div className="al-toolbar">
            <div className="al-filter-tabs">
              <button className="al-ftab all" onClick={() => setActiveTab("all")}>All Alarms (92)</button>
              <button className="al-ftab active-t" onClick={() => setActiveTab("active")}>Active <span>(92)</span></button>
              <button className="al-ftab unack" onClick={() => setActiveTab("unack")}>Unacknowledged (20)</button>
              <button className="al-ftab resolved" onClick={() => setActiveTab("resolved")}>Resolved</button>
            </div>
            <div className="al-toolbar-right">
              <div className="al-search-box">
                <span style={{ color: "#bbb" }}>🔍</span>
                <input type="text" placeholder="Search alarms..." />
              </div>
              <button className="al-tool-btn">⚡ Filters ▾</button>
              <button className="al-tool-btn">⬇ Export ▾</button>
            </div>
          </div>

          <table className="al-table">
            <thead>
              <tr>
                <th>Details <span style={{ color: "#555" }}>⇅</span></th>
                <th>Date & Time <span style={{ color: "#555" }}>⇅</span></th>
                <th>Criticality <span style={{ color: "#555" }}>⇅</span></th>
                <th>Occurrence <span style={{ color: "#555" }}>⇅</span></th>
                <th>Subscribers</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {alarms.map((alarm) => (
                <tr key={alarm.id}>
                  <td>
                    <div className="al-alarm-detail">{alarm.details}</div>
                    <span className={`al-alarm-tag${alarm.tagType === "aux" ? " aux" : ""}`}>{alarm.tag}</span>
                  </td>
                  <td>
                    <div className="al-dt-main">{alarm.time}</div>
                    {alarm.date && <div className="al-dt-sub">{alarm.date}</div>}
                  </td>
                  <td><CriticalityBadge level={alarm.criticality} /></td>
                  <td><OccBars count={alarm.occCount} color={alarm.occColor} /></td>
                  <td>
                    <div className="al-subs">
                      <span>👥</span> M Y G +2
                    </div>
                  </td>
                  <td>
                    <div className="al-action-btns">
                      <button className="al-ack-btn">Acknowledge</button>
                      <button className="al-view-btn">View</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="al-pag-row">
            <div className="al-pag-info">Showing 1 to 5 of 92 alarms</div>
            <div className="al-pag-btns">
              {["«", "‹", "1", "2", "3", "…", "19", "›", "»"].map((p, i) => (
                <button key={i} className={`al-pag-btn${p === "1" ? " active" : ""}`}>{p}</button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
    </CardBody>
    </Card>
  
    </div>
    </React.Fragment>
  );
};

export default AlarmPage;